import React from "react";
import { Button } from "components/buttons";
import { formatter } from "utils/helpers";

import CreateNewTripVault from "./CreateNewTripVault";
import { ReactComponent as InfoSquare } from "assets/icons/info-square.svg";

const VaultHolder = ({
  rate,
  packageDetails,
  vaultModal,
  setVaultModal,
  setView,
  numberOfPackages,
  closeModal,
  departureDate,
  selectedRoomRateId,
  setPaymentType,
  selectedCoupon,
  longTerm_deadline_date,
}) => {
  const handleBack = () => {
    setView(1);
    setVaultModal(null);
  };

  const handleVaultClose = () => {
    setView(null);
    setVaultModal(null);
    closeModal();
  };

  // The problem is here - this function needs to actually set the state
  const openVaultModal = () => {
    setVaultModal("createVault");
  };

  return (
    <div
      className={`py-8 px-8 bg-black-100/50 fixed top-0 left-0 w-full h-screen ${
        vaultModal === "dialog"
          ? "flex items-end lg:items-center lg:justify-center"
          : "flex justify-end"
      }  z-[999]`}
    >
      {vaultModal === "dialog" && (
        <>
          <div className="z-[9999] w-full max-w-[540px] bg-white-100 rounded-lg h-[350px] lg:h-[260px]">
            <section className="pt-4 rounded-lg mt-2 h-full text-center">
              <InfoSquare className="mx-auto" />

              <h4 className="text-base mt-4 text-[#1D2939] font-bold">
                Save for 'Trip to Ghana'
              </h4>

              <div className="text-sm text-[#525866]">
                <p className="">
                  To secure this offer in your trip vault, you are obliged to
                  pay at least{" "}
                  <span className="text-blue-400">
                    {formatter.format(Math.ceil(rate * 0.3))}{" "}
                  </span>{" "}
                  <br /> in the next 6 hours!
                </p>

                <p className="mt-1">Would you like to proceed now?</p>
              </div>

              <div className="mt-4 border-t border-black-100/20 pt-4 px-4 flex flex-col lg:flex-row gap-4 lg:justify-end">
                <Button
                  onClick={() => setVaultModal(null)}
                  className="border border-gray-50 !text-black-100 w-full lg:!w-fit px-4 py-1"
                  isWhite
                  text="No, cancel"
                />
                <Button
                  onClick={openVaultModal}
                  className="w-full lg:!w-fit px-2 py-1"
                  isBlue
                  text="Yes, Create vault & Pay"
                />
              </div>
            </section>
          </div>
        </>
      )}

      {vaultModal === "createVault" && (
        <div className="z-[9999] h-full">
          <CreateNewTripVault
            onClose={handleVaultClose}
            goBack={handleBack}
            minimum_travellers={packageDetails?.minimum_travellers}
            number_travellers={packageDetails?.number_travellers}
            rate={rate}
            numberOfPackages={numberOfPackages}
            packageDetails={packageDetails}
            departureDate={departureDate}
            selectedRoomRateId={selectedRoomRateId}
            setView={setView}
            setVaultModal={setVaultModal}
            setPaymentType={setPaymentType}
            selectedCoupon={selectedCoupon}
            longTerm_deadline_date={longTerm_deadline_date}
          />
        </div>
      )}
    </div>
  );
};

export default VaultHolder;
